module.exports = __webpack_public_path__ + "static/img/washCar.00e4621.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/washCar.png
// module id = 3cdd
// module chunks = 1